import { useContext } from 'react';
import { InsuranceReviewStore } from '../stores/insuranceReviewStore';
import { StoreContext } from '@roc/feature-app-core';

export const useInsuranceReviewStore = () => useContext<{
  insuranceReviewStore: InsuranceReviewStore
}>(StoreContext);
